import { useMutation } from '@tanstack/react-query';

import {
  apiClient,
  type ArtworkDetail,
  type PhotoArtworkCreateAndUpdateWritable,
} from '@api';

/**
 * Creates a PHOTO artwork via API.
 *
 * Required params: PhotoArtworkCreateAndUpdateWritable payload from editor output (cropped_image, optional original_image/cropped_image_state/decorations).
 * Important behavior: uses throwOnError=true and returns the created artwork detail.
 *
 * @example
 * const { mutateAsync } = useCreatePhotoArtwork();
 * await mutateAsync({ cropped_image_state: state, cropped_image: dataUrl });
 */
export const useCreatePhotoArtwork = (options: object = {}) => {
  return useMutation<ArtworkDetail, Error, PhotoArtworkCreateAndUpdateWritable>(
    {
      mutationFn: async (values) => {
        const response = await apiClient.artworksCreatePhotoArtworkCreate<true>(
          {
            body: values,
            throwOnError: true,
          }
        );
        return response.data;
      },
      ...options,
    }
  );
};
